import axios from "axios";

export default {
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/alert",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createList(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/alert/listPatients",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/alert/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    checkReadAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/alert/readall",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPaginationSend(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/alerts/pagination/send?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPagination(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/alerts/pagination?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPending(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/alerts/pending?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
